import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const AllReceiptsBlock = styled('div')`
  width: 100%;
  height: fit-content;
  margin-top: 20px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .not-available-receipts {
    font-weight: 500;
    color: ${baseTheme.colors.mainLightBlue};
    font-size: 18px;
    margin: 0;
  }

  .receipt-item {
    border: 1px solid ${baseTheme.colors.focus};
    width: 48%;
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    &:hover {
      background-color: ${baseTheme.colors.focus};
      color: ${baseTheme.colors.white};
    }

    .receipt-item-title {
      margin: 0;
      font-size: 18px;
    }

    .receipt-item-product {
      margin-bottom: 3px;
    }
  }

  @media only screen and (max-width: 1024px) {
    width: 100%;
    overflow: auto;
    padding: 0 10px;
  }
`;
